module.exports = __webpack_public_path__ + "media/images/flags/1x1/reu-cc89551733c0fc80450fe8c50777892d.svg";